module.exports = __webpack_public_path__ + "static/img/2.cf28c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/HeatTreatment/2.png
// module id = G1Ko
// module chunks = 13